<template>
  <div class="select-block">
    <div class="work-rank-box tableRankList">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item>
          <el-date-picker
            v-model="search.dateTime"
            type="date"
            style="width: 160px"
            :prefix-icon="el-icon-date"
            placeholder="作业时间">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-select
            placeholder="地区选择"
            v-model="search.cityCode"
            style="width: 160px"
            clearable
          >
            <!--<el-option
              v-for="(item, index) in countyList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>-->
             <el-option
              v-for="(item, index) in countyList"
              :key="index"
              :label="item.n"
              :value="item.i"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rankList" class="tableStyle">
        <el-table-column prop="id" label="序号" width="80" type="index">
          <template slot-scope="scope">
            <span>{{ scope.$index + addIndex }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="areaName"
          label="作业地区"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <!--<el-table-column
          prop="workDate"
          label="作业时间"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>-->
        <el-table-column
          prop="njNum"
          label="作业农机（台）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="totalArea"
          label="收获面积（亩）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="localNjNum"
          label="本省收割机数量（台）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="localTotalArea"
          label="本省收获作业面积（亩）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="kqNjNum"
          label="跨区收割机数量（台）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
        <el-table-column
          prop="kqTotalArea"
          label="跨区收获作业面积（亩）"
          :show-overflow-tooltip="true"
          popper-class="tips"
        >
        </el-table-column>
      </el-table>
      <div
        v-if="nodata"
        class="zanwu"
      >
        暂无数据
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="checkcurrentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          v-if="rankList && rankList[0]"
        >
        </el-pagination>
      </div>
      <div v-if="isloading" class="">
        <div class="el-loading-spinner">
          <i class="el-icon-loading"></i>
          <p class="el-loading-text">拼命加载中</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Api from "../../Serves/net-api.js";
	import Http from "../../Serves/net-http.js";
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "HarvestStatisticsByTime",
		components: {
		},
		data() {
			return {
        formInline: {
          user: "",
          region: ""
        },
        search: {
          dateTime: '',
          cityCode: ''
        },
        countyList: [],
				rankList: [],
        currentPage: 1,
        isloading: false,
        checkcurrentPage: 11,
        workrankName: "",
        nodata: false,
        addIndex: 1,
			}
		},
		mounted() {
      this.getCountyList(this.$store.state.info.areaCode)
      this.getData();
		},
		methods: {
      //获取省
      getCountyList(value){
        /*Api.doPost(Http.test+'/area/getCityOfProvice',{ pId: value }, false,(res)=>{
          this.countyList = res.result
        })*/
       Api.doPost(Http.test+'/screenBuyNj/getCityOfProvice ',{ pId: value }, false,(res)=>{
          this.countyList = res.result
        })
      },
      onSubmit () {
        this.currentPage = 1
        this.addIndex = 1
        this.getData()
      },
			getData() {
        var parmse = {
          p: this.currentPage,
          size: this.checkcurrentPage,
          region_id : this.search.cityCode
        }
        var url = Http.test + "/screenBuyNj/getAreaStatisticHarvesterByRegion"
        this.isloading = true
        Api.doPost(url, parmse, false, res => {
          this.isloading = false
          this.rankList = res.result.dataSource
          this.total = res.result.totalRow
        })
      },
      handleSizeChange(val) {
        this.checkcurrentPage = val
        this.currentPage = 1
        this.addIndex = 1
        this.getData()
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage
        this.addIndex = (this.currentPage - 1) * this.checkcurrentPage + 1
        this.getData();
      }
		}
	}
</script>
<style scoped>
  /deep/ .tableStyle td{
    height: 4.3vh!important;
    line-height: 4.3vh!important;
  }
  .select-block{
    margin-top: 1vh;
  }
  .demo-form-inline{
    position: absolute;
    top: -5vh;
    left: 14.5vw;
    width: 50%;
  }
	.zanwu{
    text-align: center;
    font-size: 44px;
    color:#999;
    width:100%;
    height: 600px;
    line-height: 600px;
  }
  .block{
    width: 100%;
    margin-top: 1vh;
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-table {
    color: #fff;
    position: relative;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    left: 15px;
    width: 98%;
    max-width: 100%;
    font-size: 14px;
    /* margin-top: 1vh; */
    /*background-color: #06103b !important;*/
    /* box-shadow: 0 0 29px #06103b; */
    /* -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3) !important; */
    /* border: 1px solid #06103b !important; */
  }
  .el-pager li{
    color: #fff !important;
  }
  .el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #fff !important;
  }
  p {
    color: #fff;
  }
  .tab-box {
    width: 98%;
    margin-left: 1%;
    overflow: hidden;
  }
  .work-rank-box {
    /* height:auto !important;  */
    height: 55vh; 
    overflow:visible;
    padding-top: 1vh;
    width: 100%;
    /* background-image: url("/static/img/zuoyejindu-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    position: relative;
    padding-bottom: 20px;
  }
  .rankNumber {
    height: 32px;
    line-height: 34px;
    display: inline-block;
    text-align: center;
  }
  .rankNumbers {
    width: 32px;
    height: 32px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    background: #263783;
    border-radius: 50%;
    font-size: 0.7vw;
    font-weight: 400;
  }

	
</style>


// WEBPACK FOOTER //
// src/components/TableList/HarvestStatisticsByArea.vue